import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetCurrentUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {UseCase} deps.service
   * @param {Object} deps.log
   */
  constructor({service, log}) {
    super({
      service,
      log
    })

    this._service = service
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>} returns current logged user
   * @property {Object} user
   */
  async execute() {
    this._log('Getting current user')

    const userEntity = await this._service.execute()

    return Promise.resolve(userEntity ? userEntity.toJSON() : null)
  }
}
